import { render, staticRenderFns } from "./ConversionTable.vue?vue&type=template&id=06f81cdb&scoped=true&"
import script from "./ConversionTable.vue?vue&type=script&lang=js&"
export * from "./ConversionTable.vue?vue&type=script&lang=js&"
import style0 from "./ConversionTable.vue?vue&type=style&index=0&id=06f81cdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f81cdb",
  null
  
)

export default component.exports